var toCamelCase;

toCamelCase = function(s) {
  var Word;
  if (!s) {
    throw new Error('String not defined');
  }
  Word = function(w) {
    return w.charAt().toUpperCase() + w.slice(1);
  };
  return s.split(/[-\s_.,&]+/g).map(Word).join('');
};

module.exports = {
  toCamelCase: toCamelCase
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9oZWxwZXJzL2NhbWVsQ2FzZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvc2tpbS9zbHMvc3JjL2hlbHBlcnMvY2FtZWxDYXNlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLFdBQUEsR0FBYyxTQUFDLENBQUQ7QUFDWixNQUFBO0VBQUEsSUFBd0MsQ0FBSSxDQUE1QztBQUFBLFVBQVUsSUFBQSxLQUFBLENBQU0sb0JBQU4sRUFBVjs7RUFDQSxJQUFBLEdBQU8sU0FBQyxDQUFEO1dBQU8sQ0FBQyxDQUFDLE1BQUYsQ0FBQSxDQUFVLENBQUMsV0FBWCxDQUFBLENBQUEsR0FBMkIsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxDQUFSO0VBQWxDO1NBQ1AsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxhQUFSLENBQXNCLENBQUMsR0FBdkIsQ0FBMkIsSUFBM0IsQ0FBZ0MsQ0FBQyxJQUFqQyxDQUFzQyxFQUF0QztBQUhZOztBQUtkLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2YsYUFBQSxXQURlIn0=
